import { ColumnDef } from '@tanstack/react-table'
import { Edit, Settings } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { useState } from 'react'
import { QueueMachineDialog } from './QueueMachineDialog'
import { DeleteQueueMachineDialog } from './DeleteQueueMachineDialog'
import { useViewMode } from '@/stores/viewMode'
import { QueueMachineWithRelations } from '@magnetar/admin-api-interfaces'

export const columns: ColumnDef<QueueMachineWithRelations>[] = [
  {
    accessorKey: 'queue_machine_id',
    header: 'ID',
  },
  {
    accessorKey: 'name',
    header: '叫號機名稱',
  },
  {
    accessorKey: 'channel',
    header: '頻道',
    cell: ({ row }) => {
      const channel = row.original.channel
      return channel === 'DEFAULT' ? '預設' : '內部'
    },
  },
  {
    accessorKey: 'show_patient_name',
    header: '顯示病患名稱',
    cell: ({ row }) => {
      const showPatientName = row.original.show_patient_name
      return showPatientName ? '是' : '否'
    },
  },
  {
    accessorKey: 'examination_room',
    header: '關聯診間',
    cell: ({ row }) => {
      const examinationRoom = row.original.examination_room
      return examinationRoom?.name || '未關聯'
    },
  },
  {
    accessorKey: 'created_at',
    header: '建立時間',
    cell: ({ row }) => {
      const date = new Date(row.original.created_at)
      return date.toLocaleString('zh-TW')
    },
  },
  {
    id: 'actions',
    cell: function ActionsCell({ row, table }) {
      const { id: clinicId } = useViewMode()
      const queueMachine = row.original
      const [showEditDialog, setShowEditDialog] = useState(false)
      const [showDeleteDialog, setShowDeleteDialog] = useState(false)

      return (
        <>
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="ghost" className="h-8 w-8 p-0">
                <span className="sr-only">Open menu</span>
                <Settings className="h-4 w-4" />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
              <DropdownMenuLabel>操作</DropdownMenuLabel>
              <DropdownMenuSeparator />
              <DropdownMenuItem onClick={() => setShowEditDialog(true)}>
                <Edit className="mr-2 h-4 w-4" />
                編輯
              </DropdownMenuItem>
              <DropdownMenuItem
                onClick={() => setShowDeleteDialog(true)}
                className="text-destructive"
              >
                刪除
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>

          <QueueMachineDialog
            open={showEditDialog}
            onOpenChange={setShowEditDialog}
            clinicId={clinicId}
            queueMachine={queueMachine}
            onSuccess={() => table.options.meta?.reloadData?.()}
          />

          <DeleteQueueMachineDialog
            open={showDeleteDialog}
            onOpenChange={setShowDeleteDialog}
            queueMachine={queueMachine}
            onSuccess={() => table.options.meta?.reloadData?.()}
          />
        </>
      )
    },
  },
]
